import { useEffect, useState } from 'react';
import './App.css';
import data from "./data/data.json"
import Footer from './layout/Footer/Footer';
import Header from './layout/Header/Header';
import Main from './layout/Main/Main';

export type PlanetName = "Mercury" | "Venus" | "Earth" | "Mars" | "Jupiter" | "Saturn" | "Uranus" | "Neptune";

interface PlanetInfo {
  content: string;
  source: string;
}

interface PlanetImages {
  planet: string;
  internal: string;
  geology: string;
}

export interface PlanetData {
  name: string;
  overview: PlanetInfo;
  structure: PlanetInfo;
  geology: PlanetInfo;
  rotation: string;
  revolution: string;
  radius: string;
  temperature: string;
  images: PlanetImages;
}

function App() {
  const [selectedPlanet, setSelectedPlanet]=useState<PlanetName>("Earth")
  const [selectedPlanetData, setSelectedPlanetData] = useState<PlanetData[] | null>(null)

  useEffect(()=>{
    const current:PlanetData[] = data.filter(planet => planet.name === selectedPlanet)
    setSelectedPlanetData(current)
  }, [selectedPlanet])

  const onSetPlanet = (planet:PlanetName):void =>{
    setSelectedPlanet(planet)
  }

  return (
    <div id='app'>
      <Header onSetPlanet={onSetPlanet}/>
      <Main currentPlanetData={selectedPlanetData} currentPlanet={selectedPlanet}/>
      <Footer currentPlanetData={selectedPlanetData}/>
    </div>
  );
}

export default App;